

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }



function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }



function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }



function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }



function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }



function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }



function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }



function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }



function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }



// Market (presentment currency) prices per variant id, loaded from the Ajax Product API.
// Shopify applies the exchange rate, price rounding and market price lists server-side,
// so this matches what the product page shows.
var pigmentMarketPrices = {};
var pigmentMarketPriceRequests = {};

function pigmentProductHandle(listItem) {
  var url = listItem.du || listItem.cprops && listItem.cprops.du || "";
  var match = String(url).match(/\/products\/([^\/?#]+)/);
  return match ? match[1] : null;
}

function pigmentFormatUsd(value) {
  return "USD " + Number(value).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

function pigmentApplyMarketPrice(epi) {
  var marketPrice = pigmentMarketPrices[epi];
  if (!marketPrice) return;
  var nodes = document.querySelectorAll('[data-pigment-price-epi="' + epi + '"]');
  for (var i = 0; i < nodes.length; i++) {
    var finalNode = nodes[i].querySelector(".swym-product-final-price");
    var originalNode = nodes[i].querySelector(".swym-product-original-price");
    if (finalNode) finalNode.textContent = pigmentFormatUsd(marketPrice.price);
    if (originalNode) originalNode.textContent = marketPrice.compareAtPrice ? pigmentFormatUsd(marketPrice.compareAtPrice) : "";
  }
}

function pigmentMarketPrice(listItem, component) {
  var epi = listItem.epi;
  if (pigmentMarketPrices[epi]) return pigmentMarketPrices[epi];
  var handle = pigmentProductHandle(listItem);
  if (!handle || !window.fetch) return null;
  if (!pigmentMarketPriceRequests[handle]) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/";
    pigmentMarketPriceRequests[handle] = fetch(root + "products/" + handle + ".js", { credentials: "same-origin" })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (product) {
        if (!product || !product.variants) return;
        product.variants.forEach(function (variant) {
          pigmentMarketPrices[variant.id] = {
            price: variant.price / 100,
            compareAtPrice: variant.compare_at_price && variant.compare_at_price > variant.price ? variant.compare_at_price / 100 : null
          };
        });
      })
      .catch(function () {});
  }
  pigmentMarketPriceRequests[handle].then(function () {
    if (!pigmentMarketPrices[epi]) return;
    // Prefer a re-render; patching the DOM under a live component leaves the
    // renderer's stale text node behind and the price shows twice.
    if (component && typeof component.forceUpdate === "function") {
      component.forceUpdate();
    } else {
      pigmentApplyMarketPrice(epi);
    }
  });
  return null;
}

window.SwymBeforeRender = window.SwymBeforeRender || [];

window.SwymBeforeRender.push(function (UIObj) {

  UIObj.Registry.preloadComponent('productPrice', function (OriginalComp) {

    var originalComponent = OriginalComp;



    var FormatProductPriceComponent = /*#__PURE__*/function (_OriginalComp) {

      _inherits(FormatProductPriceComponent, _OriginalComp);



      var _super = _createSuper(FormatProductPriceComponent);



      function FormatProductPriceComponent() {

        _classCallCheck(this, FormatProductPriceComponent);

        return _super.apply(this, arguments);

      }



      _createClass(FormatProductPriceComponent, [{

        key: "render",

        value: function render() {

          var ctx = this.context.UI;

          var listItem = this.props.listItem;

          var pr = listItem.pr;



          var originalPrice = this.props.productItem.op; // price formatting logic.

          var isUsd = window.pigmentPresentmentCurrency === "USD";

          // Swym returns prices in the shop currency (JPY). For USD, show the
          // market price Shopify computed (rate + rounding + price lists) by
          // reading the variant from the locale-aware Ajax Product API.
          var marketPrice = isUsd ? pigmentMarketPrice(listItem, this) : null;

          if (marketPrice) {
            pr = marketPrice.price;
            originalPrice = marketPrice.compareAtPrice;
          }



          ctx.FormatPrice = function (value) {

            if (isUsd) {
              var usdValue = Number(value);
              if (!marketPrice) {
                // Fallback until the Ajax response arrives: estimate with the storefront rate.
                var shopifyCurrency = window.Shopify && window.Shopify.currency;
                var rate = shopifyCurrency && shopifyCurrency.active === "USD" ? parseFloat(shopifyCurrency.rate) : NaN;
                if (!isNaN(rate)) usdValue = usdValue * rate;
              }
              return "USD " + usdValue.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              });
            }
            var currency = window._swat.currency;

            //set Locale to region specific
            var locale = "ja-JP";

            return currency + Math.round(value).toLocaleString(locale);

          };



          return UIObj.Renderer.createElement("div", {

            "class": "swym-product-price swym-has-sale l",

            "data-pigment-price-epi": listItem.epi

          }, UIObj.Renderer.createElement("div", {

            "class": "swym-product-final-price swym-value"

          }, ctx.FormatPrice(pr)), UIObj.Renderer.createElement("div", {

            "class": "swym-product-original-price swym-value"

          }, originalPrice ? ctx.FormatPrice(originalPrice) : ""));

        }

      }]);



      return FormatProductPriceComponent;

    }(OriginalComp);



    UIObj.Registry.register("WishlistContainer.Detail.Grid.Item.Price", FormatProductPriceComponent);

  });

});

(function () {
  var pending = null;
  var registered = false;
  function notice(text) {
    var box = document.getElementById('pigment-wishlist-status');
    if (!box) {
      box = document.createElement('div');
      box.id = 'pigment-wishlist-status';
      box.setAttribute('role', 'status');
      box.style.cssText = 'position:fixed;bottom:24px;left:16px;right:16px;max-width:560px;margin:auto;padding:16px;background:#fff;color:#111;border:1px solid #777;box-shadow:0 3px 16px #0002;z-index:2147483000;font-size:14px;line-height:1.6';
      document.body.appendChild(box);
    }
    box.textContent = text;
    return box;
  }
  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target.closest('.swym-add-to-wishlist, a.swym-wishlist') : null;
    if (!target || (window._swat && typeof window._swat.initializeActionButtons === 'function')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    pending = target;
    var ja = document.documentElement.lang.indexOf('ja') === 0;
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    var allowed = privacy && typeof privacy.preferencesProcessingAllowed === 'function' && privacy.preferencesProcessingAllowed();
    var box = notice(allowed
      ? (ja ? 'お気に入りを読み込んでいます。しばらくお待ちください。' : 'Loading your wishlist. Please wait a moment.')
      : (ja ? 'お気に入りの保存にはCookieの「パーソナライズ」の許可が必要です。Cookie設定をご確認ください。' : 'Saving wishlist items requires permission for personalization cookies. Please review your cookie preferences.'));
    if (!registered) {
      registered = true;
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(function (swat) {
        setTimeout(function () {
          swat.initializeActionButtons();
          var active = pending;
          pending = null;
          var status = document.getElementById('pigment-wishlist-status');
          if (status) status.remove();
          if (active && active.isConnected) active.click();
        }, 0);
      });
    }
    if (!allowed && window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      Promise.resolve(window.privacyBanner.showPreferences()).catch(function () {});
    }
    var close = document.createElement('button');
    close.type = 'button';
    close.textContent = ja ? '閉じる' : 'Close';
    close.style.cssText = 'display:block;margin-top:8px;text-decoration:underline;background:none;border:0;color:inherit;cursor:pointer';
    close.addEventListener('click', function () { pending = null; box.remove(); });
    box.appendChild(close);
  }, true);
})();

// Keep the wishlist page inside the current market / locale (e.g. /en, /en-us).
// Swym's hosted wishlist page is configured as "/pages/swym-wishlist" without a
// locale prefix, so the header icon fell back to the Japanese page.
(function () {
  document.addEventListener("click", function (event) {
    var link = event.target && event.target.closest ? event.target.closest("a.swym-wishlist") : null;
    if (!link) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    if (root === "/") return; // default locale: keep Swym's own behaviour
    var url = link.getAttribute("data-pigment-wishlist-url") || root.replace(/\/$/, "") + "/pages/swym-wishlist";
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.href = url;
  }, true);
})();

(function () {
  function marketUrl(value) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (!root) return null;
    try {
      var url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin) return null;
      var product = url.pathname.match(/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?(\/products\/[^/]+)\/?$/i);
      if (!product) return null;
      url.pathname = root.replace(/\/$/, '') + product[1];
      var query = new URLSearchParams(url.search.replace(/\?variant=/g, '&variant='));
      var variants = query.getAll('variant');
      if (variants.length) query.set('variant', variants[variants.length - 1]);
      url.search = query.toString();
      return url.href;
    } catch (error) {
      return null;
    }
  }

  function start() {
    var container = document.getElementById('swym-wishlist-render-container');
    if (!container || container.dataset.pigmentMarketLinks) return;
    container.dataset.pigmentMarketLinks = 'true';

    function updateLinks() {
      container.querySelectorAll('.swym-wishlist-item a[href]').forEach(function (link) {
        var value = link.getAttribute('href');
        var url = marketUrl(value);
        if (url && url !== value) link.setAttribute('href', url);
      });
    }

    function navigate(event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var item = target.closest('.swym-wishlist-item');
      if (!item || !container.contains(item)) return;
      var anchor = target.closest('a[href]');
      var title = target.closest('button');
      var titleButton = title && title.querySelector('.swym-title');
      if (!anchor && !titleButton && target !== item) return;
      if (event.type === 'keydown' && (anchor || titleButton || (event.key !== 'Enter' && event.key !== ' '))) return;
      var link = anchor || item.querySelector('a.swym-wishlist-image-wrapper[href]');
      var url = link && marketUrl(link.getAttribute('href'));
      if (!url) return;
      link.setAttribute('href', url);
      event.stopImmediatePropagation();
      if (anchor) return;
      event.preventDefault();
      if (event.ctrlKey || event.metaKey || event.shiftKey) {
        window.open(url, '_blank', 'noopener');
      } else {
        window.location.assign(url);
      }
    }

    updateLinks();
    new MutationObserver(updateLinks).observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['href']
    });
    container.addEventListener('click', navigate, true);
    container.addEventListener('keydown', navigate, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
